import React, { useEffect, useState } from "react";
import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { Header } from "../../components/Header";

export default function AdminShell() {
  const nav = useNavigate();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    document.body.classList.add("light-admin");
    if (!localStorage.getItem("cw_admin_token")) {
      nav("/admin/login");
    } else {
      setReady(true);
    }
    return () => document.body.classList.remove("light-admin");
  }, [nav]);

  const logout = () => {
    localStorage.removeItem("cw_admin_token");
    nav("/admin/login");
  };

  if (!ready) return null;
  return (
    <div className="cw-admin-shell" data-testid="admin-shell">
      <Header variant="light" />
      <div className="cw-admin-nav" data-testid="admin-nav">
        <NavLink to="/admin/deal-board" className={({ isActive }) => (isActive ? "active" : "")} data-testid="nav-deal-board">Deal Board</NavLink>
        <NavLink to="/admin/queue" className={({ isActive }) => (isActive ? "active" : "")} data-testid="nav-queue">Review Queue</NavLink>
        <NavLink to="/admin/fixtures" className={({ isActive }) => (isActive ? "active" : "")} data-testid="nav-fixtures">Fixture Bench</NavLink>
        <NavLink to="/admin/analytics" className={({ isActive }) => (isActive ? "active" : "")} data-testid="nav-analytics">Analytics</NavLink>
        <NavLink to="/admin/emails" className={({ isActive }) => (isActive ? "active" : "")} data-testid="nav-emails">Email Log</NavLink>
        <NavLink to="/admin/content" className={({ isActive }) => (isActive ? "active" : "")} data-testid="nav-content">Content</NavLink>
        <NavLink to="/admin/contact" className={({ isActive }) => (isActive ? "active" : "")} data-testid="nav-contact">Contact</NavLink>
        <NavLink to="/admin/onboarding" className={({ isActive }) => (isActive ? "active" : "")} data-testid="nav-onboarding">Onboarding</NavLink>
        <div style={{ marginLeft: "auto" }}>
          <button className="cw-btn-text" onClick={logout} data-testid="admin-logout">Sign out</button>
        </div>
      </div>
      <div className="cw-admin-body">
        <Outlet />
      </div>
    </div>
  );
}
